













































import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { MessageCommandProcessor, MediaCommandProcessor } from '@/api'
import { Mobile, EventUtils } from '@/utils'

import moment from 'moment'

@Component({
  components: { InfiniteLoading },
})
export default class MessagesList extends Vue {

  @Prop({ type: Object, required: false })
  customSendMessage: object

  @Prop({ type: Array, required: true })
  messages: any[]

  @Prop({ type: Array, required: true })
  hiddenMessages: any[]

  @Prop({ type: Object, required: true })
  translations: Object

  @Prop({ type: Function })
  loadMore: () => {}

  @Getter authHeader: string
  @Getter authenticadedMedias: boolean
  @Getter openImageInFrame: boolean

  onUnsupportedType(document) {
    console.log('Card não suportado')
  }

  dispatchScrollEvent() {
    const messagesList = document.querySelector('.ss-content')
    if (messagesList) {
      let event
      if (typeof Event === 'function') {
        event = new Event('force-scroll')
      } else {
        event = document.createEvent('Event')
        event.initEvent('force-scroll', true, true)
      }
      messagesList.dispatchEvent(event)
    }
  }

  focusOnTextArea() {
    const textarea = document.getElementById('msg-textarea')
    if (textarea) {
      textarea.focus()
    }
  }

  onSelected(text, payload) {
    if (Mobile.isMobile() && Mobile.isKeyboardOpen()) {
      this.focusOnTextArea()
    }

    let payloadContent
    try {
      payloadContent = JSON.parse(payload.content)
    } catch (e) {
      payloadContent = payload.content
    }

    const msg = {
      type: payload.type,
      content: payloadContent,
      metadata: {
        '#blip.payload.content': text,
      },
    }
    MessageCommandProcessor.send(this.customSendMessage, msg)
    this.dispatchScrollEvent()
  }

  onOpenLink(weblink: any) {
    EventUtils.OpenWebview(weblink)
  }

  onLocationError(error) {
    let errorMessage = ''
    switch (error.code) {
      // Permission Denied
      case 1:
        errorMessage = 'A permissão para localização foi negada'
        break
      default:
        errorMessage = 'Não foi possível obter a localização'
        break
    }

    EventUtils.ShowError(errorMessage)
  }

  groupMessages(msg1, msg2) {
    return (
      msg1.position === msg2.position &&
      moment(msg2.createDate).diff(moment(msg1.createDate), 'seconds') <= 60
    )
  }

  showNotification(msg) {
    return true
  }

  private isExpiredContentUri(mediaUri: any) {
    if (!mediaUri) {
      return false
    }

    const params = new URLSearchParams(mediaUri)
    const se = params.get('se')
    const expireDate = se ? new Date(se) : null
    const actualDate = new Date()

    if (expireDate && actualDate > expireDate) {
      return true
    }

    return false
  }

  private async validateUriUpdate(uri: string) {
    let newUri = uri

    if (this.isExpiredContentUri(uri)) {
      newUri = await MediaCommandProcessor.refreshContentUri(uri)
    }

    return newUri
  }

  async openUriInBlank(uri: string) {
    const newUri = await this.validateUriUpdate(uri)

    window.open(newUri, '_blank')
  }

  getCreateOpenImageInFrameDataByUri(uri: string) {
    return {
      uri: uri,
      target: 'self',
      title: '',
      image: ''
    }
  }

  async openUriInWebView(uri: string) {
    const newUri = await this.validateUriUpdate(uri)

    const openUriData = this.getCreateOpenImageInFrameDataByUri(newUri);

    if(this.openImageInFrame) {
      EventUtils.OpenWebview(openUriData)
      return
    }

    window.open(newUri, '_blank')
  }

  asyncFetchMediaWithAuthorization(authorization: string) {
    return async (document: any) => {
      const response = await fetch(document.uri, {
        headers: { Authorization: authorization },
        cache: 'force-cache'
      })
      return response
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessagesList.vue